import { Avatar, Tooltip, Typography } from "@mui/material";
import { Box, SxProps } from "@mui/system";
import { ProjectListDto } from "~/api/GeneratedApi";

export function stringToColor(string: string) {
  let hash = 0;
  let i;

  /* eslint-disable no-bitwise */
  for (i = 0; i < string.length; i += 1) {
    hash =
      string.split("").reverse().join().charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = "#";

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }
  /* eslint-enable no-bitwise */

  return color;
}

function stringAvatar(name: string): {
  sx: SxProps;
  children: JSX.Element | string;
} {
  return {
    sx: {
      bgcolor: stringToColor(name),
      width: "46px",
      height: "46px",
    },
    children: `${name.split(" ")[0][0]}${name.split(" ")[1][0]}`,
  };
}

type ProjectNavBarProps = ProjectListDto;

export const ProjectNavBar = ({ name, id }: ProjectNavBarProps) => {
  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "auto 1fr",
        columnGap: "10px",
        alignItems: "center",
      }}
    >
      <Tooltip title={name ?? ""}>
        <Avatar {...stringAvatar(name ?? "Default user")} />
      </Tooltip>

      <Box>
        <Typography fontWeight="bold" variant="h4">
          {name}
        </Typography>
        <Typography>{id}</Typography>
      </Box>
    </Box>
  );
};
